import { useEffect, useState } from 'react';

// getIsQuizProctored()/isLive derive off Date.now() vs quizDetails.start_time,
// but a component only re-evaluates that on its own re-renders - if it mounts
// before start_time and nothing else changes, it never notices the clock
// crossing start_time. This forces exactly one re-render at that moment so
// every consumer (Layout deciding whether to mount ProctorProvider included)
// picks up the live/proctored transition without needing a page refresh.
const useQuizStartTick = (startTime) => {
  const [, forceUpdate] = useState(0);

  useEffect(() => {
    if (!startTime) return undefined;

    const startTimeMs = new Date(startTime).getTime();
    if (!Number.isFinite(startTimeMs)) return undefined;

    const msUntilStart = startTimeMs - Date.now();
    if (msUntilStart <= 0) return undefined;

    const timerId = setTimeout(() => {
      forceUpdate((tick) => tick + 1);
    }, msUntilStart);

    return () => clearTimeout(timerId);
  }, [startTime]);
};

export default useQuizStartTick;
